import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import DeleteIcon from '@material-ui/icons/Delete'
import { connect } from 'react-redux'
import { eliminarVentaExportador } from '../../actions'
import { DialogConfirmacionContent } from '../../../Dialogos/DialogConfirmacionContent'

function EliminarVenta (props) {
  const { data, eliminarVentaExportador } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = () => {
    console.log('data: ', data)
    eliminarVentaExportador(data.id)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleDelete}
          title='Eliminar compra de cereal'
          content={<DialogConfirmacionContent message='¿Esta seguro que desea eliminar la compra de cereal a la terminal?' />}
        />
      </Dialog>
      <Tooltip title={'Eliminar'}>
        <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  eliminarVentaExportador
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EliminarVenta)
